module.exports = __webpack_public_path__ + "assets/img/pix.a5220db2.png";